import styled from 'styled-components';

export const StyledPrivateMessageList = styled.div.attrs((props) => ({
  className: props.className,
}))`
  position: absolute;
  width: 100%;
`;
